import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["attribution", "logoSrc"];
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Image from '../Image/Image';
import Text from '../Text/Text';
import { PropertyCardMLSFooterMixin } from '../../mixins/components/PropertyCardMLSFooterMixin';
export var StyledPropertyCardMLSFooter = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardMLSFooter",
  componentId: "c11n-8-64-0__sc-1ds3geg-0"
})(["", ""], PropertyCardMLSFooterMixin);
/**
 * Displays an MLS's logo and attribution text across the bottom of the photo.
 * Includes a gradient background to make the text easier to see over the photo.
 *
 * @since 8.63.0
 */

var PropertyCardMLSFooter = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var attribution = _ref.attribution,
      logoSrc = _ref.logoSrc,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledPropertyCardMLSFooter, _extends({
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(Text, null, attribution), logoSrc && /*#__PURE__*/React.createElement(Image, {
    src: logoSrc,
    alt: attribution || '',
    "aria-hidden": true
  }));
});
PropertyCardMLSFooter.displayName = 'PropertyCard.MLSFooter';
PropertyCardMLSFooter.propTypes = {
  /**
   * The MLS attribution text. Displayed next to the MLS logo and used for alt text.
   *
   * Ex: "Listing provided by NWMLS"
   */
  attribution: PropTypes.string,

  /**
   * The URL for the MLS logo.
   */
  logoSrc: PropTypes.string
};
export default PropertyCardMLSFooter;